import { Box } from '@factorialco/deprecated-design-system'

import Text from 'modules/core/components/Inputs/Text'

import useIdentifierForm, {
  IdentifierFieldName,
} from 'modules/payroll_employees/hooks/useIdentifierForm'
import { SupportedCountry } from 'modules/payroll_employees/lib/enums'

const COUNTRY = SupportedCountry.Portugal
const SSN_LABEL = 'Número de Identificação de Segurança Social'
const TAX_ID_LABEL = 'Número de Identificação Fiscal'

interface Props {
  employeeId: number
  mandatory: boolean
  readonly: boolean
  setSubmitEventHandler: (eventHandler: () => void) => void
  setIdentifiersDirty: (dirty: boolean) => void
}

const Portugal = ({
  employeeId,
  mandatory,
  readonly,
  setSubmitEventHandler,
  setIdentifiersDirty,
}: Props) => {
  const form = useIdentifierForm({
    employeeId: employeeId,
    country: COUNTRY,
    setSubmitEventHandler,
  })

  return (
    <Box gap="s24" width="full">
      <Text
        mandatory={mandatory}
        readonly={readonly}
        label={SSN_LABEL}
        field={form.get(IdentifierFieldName.SocialSecurityNumber)}
        onChange={() => {
          setIdentifiersDirty(form.isDirty)
        }}
        placeholder="11111111128"
      />
      <Text
        mandatory={mandatory}
        readonly={readonly}
        label={TAX_ID_LABEL}
        field={form.get(IdentifierFieldName.TaxId)}
        onChange={() => {
          setIdentifiersDirty(form.isDirty)
        }}
        placeholder="501442600"
      />
    </Box>
  )
}

export default Portugal
